import Mini, { MiniProps } from "./Mini";
import Typography, { ITypography } from "./Typography";
import React from "react";

export interface TextComponents {
	Mini: React.FC<MiniProps>;
	Typography: React.FC<ITypography>;
}

const Text: TextComponents = {
	Mini,
	Typography,
};

export default Text;
